export var valuesDeviceType = ["iOS", "Android", "Browser"];
/*

*/ 
//# sourceMappingURL=DeviceType.js.map